import React, { FC } from 'react'
import { LinkCompoundProps } from './LinkCompound.types'
import { cleanLink } from '@ampdx/common-utils/src'
import { buttonType } from '../../../../utils/linkUtil'

export const LinkCompound: FC<LinkCompoundProps> = props => {
  const {
    type,
    href,
    target,
    text,
    analytics,
    classes = [],
    shouldGrow,
    block,
    small,
    reversed,
    actionBlue,
    loading,
    isDestructive,
    linkAltText,
    handleClick,
    disabled,
    template,
    columnSize,
    neutral,
  } = props

  const cleanedHref = cleanLink(href || '')
  const cleanedAnalytics = cleanLink(analytics || '')
  const cleanedText = cleanLink(text || '')

  const destructive = isDestructive ? 'is-destructive' : ''

  const iconBlockProperty =
    type && type === 'icon' && block && block === 'true' ? 'Button--icon--stroke' : ''
  const blockProperty = block
    ? 'Button--block u-flexAlignItemsCenter u-flexJustifyCenter'
    : template === 'Microsite' && columnSize === 'customConstrainedLeft'
    ? 'Button--block u-flexAlignItemsCenter u-flexJustifyCenter u-marginTop16'
    : template === 'Microsite' && columnSize === 'customConstrainedRight'
    ? 'Button--block u-flexAlignItemsCenter u-flexJustifyCenter u-marginTop32 u-lg-size9of10 u-md-size10of10 u-sm-size10of10'
    : ''

  const customPropertyForLoading =
    type && type === 'primary' && loading && loading === 'true' ? 'Button--primary--loading' : ''
  const smallProperty = small ? 'Button--small' : ''
  const reversedProperty = reversed ? 'Button--reversed' : ''
  const actionBlueProperty = actionBlue
    ? 'Button--secondary--action-blue u-textColorActionBlue'
    : ''
  const linkReverseProperty =
    type && type === 'link' && reversed && reversed === 'true' ? 'Link--reversed' : ''
  const typeProperty = buttonType(type)
  const tertiaryReverseCheck =
    typeProperty === 'Button Button--tertiary' && reversed ? 'u-textColorWhite' : ''

  const iconNeutralProperty =
    type && type === 'icon' && neutral && neutral === 'true' && !reversed
      ? 'Button--icon--neutral'
      : ''
  if (typeof handleClick === 'function') {
    return (
      <button
        className={`${typeProperty} ${blockProperty} ${smallProperty} ${reversedProperty} ${actionBlueProperty} ${customPropertyForLoading} ${iconBlockProperty} ${linkReverseProperty}
       ${Array.isArray(classes) ? classes.join(' ') : classes} ${
          shouldGrow ? ' u-flexGrow' : ''
        } ${destructive} ${tertiaryReverseCheck} ${iconNeutralProperty}`}
        onClick={handleClick}
        data-testid='link'
        aria-label={linkAltText || text}
        data-analytics={cleanedAnalytics}
        disabled={disabled || false}
      >
        {!typeProperty.includes('icon') && cleanedText}
        {loading && loading === 'true' && (
          <div className='Loading Loading--small'>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
          </div>
        )}

        {type && type === 'icon' && (
          <div>
            <span className='u-hiddenVisually'>{cleanedText}</span>
            <span data-icon='expand_more' aria-hidden='true'>
              expand_more
            </span>
          </div>
        )}
      </button>
    )
  }
  return (
    <a
      className={`${typeProperty} ${blockProperty} ${smallProperty} ${reversedProperty} ${actionBlueProperty} ${customPropertyForLoading} ${iconBlockProperty} ${linkReverseProperty}
       ${Array.isArray(classes) ? classes.join(' ') : classes} ${
        shouldGrow ? ' u-flexGrow' : ''
      } ${destructive} ${tertiaryReverseCheck} ${iconNeutralProperty}`}
      href={encodeURI(cleanedHref)}
      data-testid='link'
      target={target}
      aria-label={linkAltText || ''}
      data-analytics={cleanedAnalytics}
    >
      {!typeProperty.includes('icon') && cleanedText}
      {type && type === 'primary' && loading && loading === 'true' && (
        <div className='Loading Loading--small'>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
          <div className='Loading-indicator'></div>
        </div>
      )}
      {type && type === 'icon' && (
        <div>
          <span className='u-hiddenVisually'>{cleanedText}</span>
          <span data-icon='expand_more' aria-hidden='true'>
            expand_more
          </span>
        </div>
      )}
    </a>
  )
}
